export const DOMAIN = 'https://simon-back-production.up.railway.app'
export const DOMAINmylims = 'http://54.207.206.5:9001'
//export const DOMAIN = 'http://localhost:3333'
